export default {"id":"1c2f3bd3","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}